/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import months from '@bd-uikit-web/data/months.json';
import countries from '@bd-uikit-web/data/countries.json';
import usStates from '@bd-uikit-web/data/us-states.json';
import genders from '@bd-uikit-web/data/genders.json';
import { Show } from '@bd-uikit-web/React/Utils';
import { Form, Select } from '@bd-uikit-web/React/Form';
import FormHelper from '@bd-uikit-web/React/FormHelper';
import SimpleModal from '@bd-uikit-web/React/SimpleModal';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import Icon from '@bd-uikit-web/React/Icon';
import autobind from '@bd-uikit-web/js-helpers/autobind';
import { StripeProvider } from 'react-stripe-elements';
import getEnvName from '@bd-uikit-web/js-helpers/getEnvName';
import StripeCardAddition from '../components/StripeCardAddition';

import { UploadAreaImg } from '../components/UploadArea';

export default class EditProfile extends React.Component {
  constructor(props) {
    super();

    this.props = props;
    const { user } = bdAuth.getUser(true) || {};
    this.state = {
      openEditCardModal: false,
      sending: false,
      user,
      userImg: {},
      // eslint-disable-next-line react/no-unused-state
      userData: null,
      passwordData: null,
      selectedCountry: null,
      cards: [],
      updateCard: {},
      showPictureUpload: true,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onFormSubmitPassword = this.onFormSubmitPassword.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.fHupdate = new FormHelper((updateCard) => this.setState({ updateCard }));
    this.fH = new FormHelper((formData) => this.setState({ userData: formData }));
    this.fHPassword = new FormHelper((formData) => this.setState({ passwordData: formData }));
    this.days = [];
    for (let i = 1; i <= 31; i++) {
      this.days.push(i);
    }
    this.years = [];
    const baseYear = new Date().getFullYear();
    for (let i = 0; i <= 99; i++) {
      this.years.push(baseYear - i);
    }
  }

  componentWillMount() {
    if (!bdAuth.isAuthenticated()) {
      rootDispatcher.dispatch('EDITPROFILE');
      this.props.history.push('/');
      return;
    }
    this.getUser();
    this.getCards();
  }

  componentDidMount() {
    bdReq.get(bdAuth.getUserEndpoint()).then(({ body: { user } }) => {
      this.fH.setStorage(user);
      this.setState({
        userImg: user,
        showPictureUpload: !user.media,
      });
    });
  }

  @autobind
  newCard(card) {
    // add this card to state of cards
    const { cards } = this.state;
    cards.push(card);
    this.setState({
      cards,
    });
    this.getCards();
  }

  @autobind
  onFormSubmit(data) {
    const { sending, selectedCountry, user } = this.state;
    if (sending) {
      return false;
    }

    if (selectedCountry !== 'United States') {
      data.state = null;
    }

    data.dateOfBirth = this.formatDate(data.year, data.month, data.day);
    const apiLink = `/users/${user.id}`;

    this.setStateSending();
    bdReq
      .put(apiLink, data)
      .then(({ success, body }) => {
        if (!success) {
          this.showNotiBanner('error', body.message);
          this.unsetStateSending();
          return false;
        }
        return bdAuth.storeUser();
      })
      .then(() => {
        this.showNotiBanner('success', 'Your account settings have been updated');
        this.unsetStateSending();
        this.getUser();
      });

    return true;
  }

  @autobind
  updateCard(card) {
    this.setState({ card });
    card.validThru = `${card.exp_month}/${card.exp_year.toString().substr(-2)}`;
    this.fHupdate.setStorage(card);
    this.setState({ openEditCardModal: true, updateCard: card });
  }

  onFormSubmitPassword() {
    const { sending, passwordData, user } = this.state;
    if (sending) {
      return false;
    }

    if (passwordData.password !== passwordData.passwordAgain) {
      this.showNotiBanner('error', 'Your repeat password should match your password');
      return false;
    }

    const apiLink = `/users/${user.id}/password`;

    this.setStateSending();
    bdReq.put(apiLink, passwordData).then(({ success, body }) => {
      if (!success) {
        this.unsetStateSending();
        this.showNotiBanner('error', body.message);
        return;
      }

      this.fHPassword = new FormHelper((formData) => this.setState({ passwordData: formData }));

      this.unsetStateSending();
      this.showNotiBanner('success', body.message);
    });
    return true;
  }

  @autobind
  editPaymentCard(card) {
    const { user } = this.state;
    const value = card.validThru.trim();
    const expMonth = value.substr(0, value.indexOf('/'));
    let expYear = value.substr(value.indexOf('/') + 1);
    if (expYear.length === 3) {
      expYear = value.substr(value.indexOf('/') + 2);
    }
    if (expYear.length === 4) {
      expYear = value.substr(value.indexOf('/') + 3);
    }
    const cardId = card.id;
    const data = {
      name: card.name,
      exp_month: expMonth,
      exp_year: expYear,
    };
    const apiLink = `/users/${user.id}/cards/${cardId}`;
    bdReq.put(apiLink, data).then(({ success, body }) => {
      if (success) {
        this.showNotiBanner('success', 'Card updated successfully');
        this.setState({ openEditCardModal: false });
        return;
      }
      rootDispatcher.dispatch('NB:OPEN', {
        type: 'error',
        msg: body.message,
      });
    });
  }

  @autobind
  deleteCard(cardId) {
    const { cards, user } = this.state;
    const apiLink = `/users/${user.id}/cards/${cardId}`;
    bdReq.delete(apiLink).then(({ success, body }) => {
      if (success) {
        this.showNotiBanner('success', 'Card deleted successfully');
        const newCards = cards.filter((card) => card.id !== cardId);
        this.setState({
          cards: newCards,
        });
        this.setState({ openEditCardModal: false });
        return;
      }

      rootDispatcher.dispatch('NB:OPEN', {
        type: 'error',
        msg: body.message,
      });
    });
  }

  @autobind
  getCards() {
    const { user } = this.state;
    bdReq.get(`/users/${user.id}/cards`).then(({ success, body: cards }) => {
      if (!success) {
        this.showNotiBanner('error', cards);
        return;
      }
      this.setState({
        cards,
      });
    });
    return true;
  }

  @autobind
  getUser() {
    // getUser is synchronous now
    const { user } = this.state;
    if (user !== null) {
      // Format the date from the api into a useable format.
      user.dateOfBirth = new Date(Date.parse(user.dateOfBirth));
      this.fH.setStorage(user);
      this.setState({
        sending: false,
        selectedCountry: user.country,
        user,
      });
      return;
    }
    this.showNotiBanner('error', 'The account could not be found');
  }

  @autobind
  onProfilePicUploadComplete(res) {
    const { user, userImg } = this.state;
    const { id: fileId, location } = res;
    bdReq.put(`/users/${user.id}`, { image: fileId }).then(({ success }) => {
      if (success) {
        user.media.images.avatar.high = location;
        this.setState({ user, showPictureUpload: false });
        userImg.media.images.avatar.high = location;
        this.setState({ userImg, showPictureUpload: false });
      }
      rootDispatcher.dispatch('NB:OPEN', {
        type: success ? 'success' : 'error',
        msg: success
          ? 'Your profile picture was uploaded successfully'
          : 'Your profile picture could not be uploaded. Try again later.',
      });
    });
  }

  // @todo move this to a static global place.
  setStateSending() {
    this.setState({
      sending: true,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  formatDate(year, month, day) {
    return `${year}-${month}-${day}`;
  }

  // eslint-disable-next-line class-methods-use-this
  showNotiBanner(type, message) {
    rootDispatcher.dispatch('NB:OPEN', {
      type,
      msg: message,
    });
  }

  handleCountryChange(e) {
    this.setState({
      selectedCountry: e.target.value,
    });
  }

  unsetStateSending() {
    this.setState({
      sending: false,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  img(brand) {
    switch (brand) {
      case 'Visa':
        return <img src="/assets/img/visa.svg" alt="Visa" className="payment__img" />;
      case 'American Express':
        return <img src="/assets/img/american-express.svg" alt="American Express" className="payment__img" />;
      case 'Diners Club':
        return <img src="/assets/img/diners_club.svg" alt="Diners Club" className="payment__img" />;
      case 'JCB':
        return <img src="/assets/img/JCB.svg" alt="JCB" className="payment__img" />;
      case 'MasterCard':
        return <img src="/assets/img/mastercard.svg" alt="MasterCard" className="payment__img" />;
      case 'UnionPay':
        return (
          <img src="/assets/img/UnionPay.svg" alt="UnionPay" className="payment__img" style={{ height: '35px' }} />
        );
      case 'Discover':
        return <img src="/assets/img/discover.svg" alt="Discover" className="payment__img" />;
      default:
    }
  }

  render() {
    const {
      userImg: { media },
      showPictureUpload,
      user,
      selectedCountry,
      sending,
      cards,
      openEditCardModal,
      card,
    } = this.state;
    const DeleteCard = (
      <a onClick={() => this.deleteCard(card.id)} className="btn btn--push btn--dark" style={{ marginTop: '1.5em' }}>
        Delete Card
      </a>
    );
    const countryOptionNodes = countries.map(({ code, name }) => (
      <option key={code} value={name}>
        {name}
      </option>
    ));
    countryOptionNodes.unshift(
      <option key="-" value="-">
        -
      </option>
    );

    return (
      <div>
        <Show condition={user === null} className="spinner container container--push" />

        <Show condition={user !== null}>
          <Form onSubmit={this.onFormSubmit}>
            <section className="row">
              <div className="col-12">
                <h4 className="h--underline h--regular-weight">Edit Profile</h4>
              </div>

              <div className="col-12">
                <div className="card">
                  <section className="row">
                    <div className="col-12 col-sm-full">
                      {!showPictureUpload ? (
                        <div>
                          <div className="profile-pic" style={{ backgroundImage: `url(${media.images.avatar.high})` }}>
                            <a
                              onClick={() => this.setState({ showPictureUpload: true })}
                              className="profile-pic__edit-btn"
                            >
                              <Icon name="edit" />
                            </a>
                          </div>
                        </div>
                      ) : (
                        <UploadAreaImg
                          onComplete={this.onProfilePicUploadComplete}
                          icon="person"
                          instructionText="Drag & drop your profile image here"
                          subline="Max. filesize 5MB"
                          maxFileSizeMB={5}
                          allowedTypes={['image/png', 'image/jpeg']}
                        />
                      )}
                    </div>
                    <div className="col-6 col-sm-full">
                      {this.fH.getInput('First Name', 'givenName', 'First name', { required: true, type: 'text' })}
                    </div>
                    <div className="col-6 col-sm-full">
                      {this.fH.getInput('Last Name', 'surname', 'Last name', { required: true, type: 'text' })}
                    </div>
                  </section>
                  <section className="row">
                    <div className="col-6 col-sm-full ">
                      {this.fH.getInput('E-mail', 'email', 'example@gmail.com', {
                        type: 'text',
                        disabled: true,
                        style: { opacity: '.8', background: '#eee', color: '#aaa' },
                      })}
                    </div>
                    <div className="col-6 col-sm-full">
                      <Select
                        name="gender"
                        label="Gender"
                        defaultValue={user.gender}
                        children={genders.map((gender, i) => (
                          <option key={i} value={gender}>
                            {gender}
                          </option>
                        ))}
                        invalidMsg="Please enter your gender"
                        required
                      />
                    </div>
                  </section>

                  <section className="row">
                    <div className="col-6 col-sm-full">
                      <Select
                        name="country"
                        label="Country"
                        onChange={this.handleCountryChange}
                        defaultValue={user.country}
                        children={countryOptionNodes}
                      />
                    </div>
                    <div className="col-6 col-sm-full">
                      <Show condition={selectedCountry === 'United States'}>
                        <Select
                          name="state"
                          label="State"
                          defaultValue={user.state}
                          children={usStates.map(({ code, name }) => (
                            <option key={code} value={name}>
                              {name}
                            </option>
                          ))}
                        />
                      </Show>
                    </div>
                  </section>

                  <section className="row">
                    <div className="col-6 col-sm-full ">
                      <div data-required="true">
                        <label className="form__desc-label">
                          <strong>Date of Birth</strong>
                        </label>
                        <div className="row">
                          <div className="col-4 col--no-left-pad">
                            <Select
                              name="day"
                              defaultValue={user.dateOfBirth.getDate()}
                              children={this.days.map((day, i) => (
                                <option value={day} key={i}>
                                  {day}
                                </option>
                              ))}
                              invalidMsg="Please enter the day"
                              required
                            />
                          </div>
                          <div className="col-4 col--half-pad">
                            <Select
                              name="month"
                              defaultValue={user.dateOfBirth.getMonth() + 1}
                              children={Object.keys(months).map((key) => {
                                const { name, short, number } = months[key];
                                return (
                                  <option value={number} key={short}>
                                    {name}
                                  </option>
                                );
                              })}
                              invalidMsg="Please enter the month"
                              required
                            />
                          </div>
                          <div className="col-4 col--no-right-pad">
                            <Select
                              name="year"
                              defaultValue={user.dateOfBirth.getFullYear()}
                              children={this.years.map((year, i) => (
                                <option value={year} key={i}>
                                  {year}
                                </option>
                              ))}
                              invalidMsg="Please enter the year"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-full ">
                      {this.fH.getInput('Mobile number', 'phoneNumber', '555 444 3333', {
                        required: false,
                        type: 'text',
                      })}
                    </div>
                  </section>

                  <section className="row">
                    <div className="col-6 col-sm-full">
                      <button className="pull-left" disabled={sending} type="submit">
                        Save Changes
                      </button>
                    </div>
                  </section>
                </div>
              </div>
            </section>
          </Form>

          <section className="row">
            <div className="col-12">
              <h4 className="h--underline h--regular-weight">Payment Details</h4>
            </div>
            <div className="col-12">
              <StripeProvider
                apiKey={
                  getEnvName() === 'production'
                    ? 'pk_live_8YPTwOAeydlQbXQKYSHVDAI6'
                    : 'pk_test_CwFNQLF0fkyOp98BpMWd97hD'
                }
              >
                <StripeCardAddition newCard={this.newCard} />
              </StripeProvider>
            </div>
          </section>

          <section className="row">
            <div className="col-12">
              {cards.map((card) => (
                <div key={card.id}>
                  <div className="current-plan-card payment__current-plan-card-padding card-width cc">
                    <section className="row" style={{ marginTop: '15px' }}>
                      <div className="col-6 col-ngr">
                        <a
                          onClick={() => this.updateCard(card)}
                          className="payment__a"
                          style={{ textUnderlinePosition: 'under' }}
                        >
                          <h6 className="h--lower h--no-spacing payment__h6-size edit">Edit Card</h6>
                        </a>
                      </div>
                      <div className="col-6 col-ngl">{this.img(card.brand)}</div>
                    </section>
                    <section className="row row--push-btm-xs" />
                    <section className="row">
                      <div className="col-3 col-ngr numbers">*&nbsp;&nbsp;*&nbsp;&nbsp;*&nbsp;&nbsp;*</div>
                      <div className="col-3 col-ng text-center numbers">*&nbsp;&nbsp;*&nbsp;&nbsp;*&nbsp;&nbsp;*</div>
                      <div className="col-3 col-ng text-center numbers">*&nbsp;&nbsp;*&nbsp;&nbsp;*&nbsp;&nbsp;*</div>
                      <div className="col-3 numbers col-ngl " style={{ textAlign: 'right' }}>
                        {card.last4}
                      </div>
                    </section>
                    <section className="row row--push-btm-xs" />
                    <section className="row">
                      <div className="col-7 col-ngr">
                        <h6 className="h--lower h--no-spacing payment__addCardColor payment__fontweight">
                          Card Holder
                        </h6>
                        <span className="h--lower payment__h6color payment__h6-size">{card.name}</span>
                      </div>
                      <div className="col-5">
                        <h6
                          className="h--lower h--no-spacing payment__addCardColor payment__fontweight"
                          style={{ textAlignLast: 'right' }}
                        >
                          Expires
                        </h6>
                        <span className="h--lower payment__h6color  payment__h6-size payment__h6-size__last-digit right">
                          {card.exp_month} / {card.exp_year.toString().substr(-2)}
                        </span>
                      </div>
                    </section>
                  </div>
                </div>
              ))}
            </div>
          </section>
          <SimpleModal open={openEditCardModal}>
            <div className="row">
              <div className="col-12 edit-payment__padding">
                <Form onSubmit={() => this.editPaymentCard(card)}>
                  <section className="row">
                    <h4 className="h--lower">Edit Card</h4>
                  </section>
                  <section className="row row-margin-bottom">
                    <div className="col-5 col-ngl col-sm-full">
                      {this.fHupdate.getInput('Card holder', 'name', 'John Doe', { required: true, type: 'text' })}
                    </div>
                    <div className="col-3 col-ngl col-sm-full">
                      {this.fHupdate.getInput('Valid Thru', 'validThru', 'MM/YY', { required: true, type: 'text' })}
                    </div>
                    <div className="col-4 col-ngl col-sm-full ">
                      <a
                        onClick={() => this.deleteCard(card.id)}
                        className="btn btn--push btn--dark"
                        style={{ marginTop: '1.5em' }}
                      >
                        Delete Card
                      </a>
                    </div>
                  </section>
                  <button type="submit" className="pull-left h--lower">
                    Save Changes
                  </button>
                </Form>
              </div>
            </div>
            <style>{' .modal__box{ width:50vw; min-height:30vh } '}</style>
          </SimpleModal>

          <Show condition={user.facebookUserId === null}>
            <Form onSubmit={this.onFormSubmitPassword}>
              <section className="row">
                <div className="col-12  col-sm-full ">
                  <h4 className="h--underline h--regular-weight">Change Password</h4>
                </div>

                <div className="col-12">
                  <div className="card">
                    <section className="row">
                      <div className="col-6 col-sm-full ">
                        {this.fHPassword.getInput('Old Password', 'oldPassword', null, {
                          required: true,
                          type: 'password',
                        })}
                        {this.fHPassword.getInput('New Password', 'password', null, {
                          required: true,
                          type: 'password',
                        })}
                        {this.fHPassword.getInput('Repeat New Password', 'passwordAgain', null, {
                          required: true,
                          type: 'password',
                        })}
                        <button className="pull-left" disabled={sending} type="submit">
                          Change Password
                        </button>
                      </div>

                      <div className="col-6 " />
                    </section>
                  </div>
                </div>
              </section>
            </Form>
          </Show>
        </Show>
      </div>
    );
  }
}
